import React from 'react';
import styles from './Components.module.css';
import smallLogo from '../studio/assets/green_logo_small.png';

const BlockMobileModal: React.FC = () => {
  return (
    <div className={styles.blockMobileModal}>
      <div className={styles.blockMobileContent}>
        <img src={smallLogo} alt="small giide logo" />
        <h1>Welcome to Giide!</h1>
        <p>
          <strong>It looks like you're on a mobile device.</strong>
        </p>
        <p>
          The giide creation process is best experienced on a larger screen.
          Please visit us on desktop to start making giides!
        </p>
      </div>
    </div>
  );
};

export default BlockMobileModal;
